import React, { useEffect, useState } from "react";
import classes from "./HeaderStyles.module.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MobileNav from "../MobileNav/MobileNav";

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [navIsToggled, setNavIsToggled] = useState<boolean>(false);
  const [isScrolled, setIsScrolled] = useState<boolean>(false);

  const toggleNavBar = () => {
    setNavIsToggled(!navIsToggled);
  };

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <header
        className={`${classes.header} ${isScrolled ? classes.scrolled : ""}`}
      >
        <div className={classes.logoWrapper} onClick={() => navigate("/")}>
          <img className={classes.logoImg} src="/sprinter.png" alt="Sprinterwave logo" />
          <h3 className={classes.logoText}>Sprinterwave</h3>
        </div>

        <nav className={classes.nav}>
          <ul>
            {NAV_LINKS.map((link) => (
              <li key={link.to} className={classes.desktop_only}>
                <Link
                  to={link.to}
                  className={
                    location.pathname === link.to ? classes.active : ""
                  }
                >
                  {link.label}
                </Link>
              </li>
            ))}

            <li className={classes.desktop_only}>
              <Link to={"/rider"}>
                <button className={classes.download_btn}>
                  Drive with Us
                </button>
              </Link>
            </li>

            <li className={classes.mobile_only}>
              <i className={classes.hamburgerIcon} onClick={toggleNavBar}>
                <GiHamburgerMenu size={22} />
              </i>
            </li>
          </ul>
        </nav>
      </header>

      {navIsToggled && <MobileNav onCLosehandler={toggleNavBar} />}
    </>
  );
};

export default Header;